import { createAction, props } from '@ngrx/store';
import { RoleEnum, UserClaims } from '../models';

export const SaveCurrentUserDataAction = createAction(
  '[Auth/User] Save current user calculated data',
  props<{ currentUser: UserClaims; reducedRole: RoleEnum }>()
);
